import * as yup from 'yup';
import { validateCNPJ } from './validateCNPJ';
import { validateCPF } from './validateCPF';

export const supplierFormSchema = yup.object().shape({
  cnpj: yup
    .string()
    .nullable()
    .required('Digite um CNPJ')
    .test('isValidCNPJ', 'Digite um CNPJ válido', function () {
      const { cnpj } = this.parent;
      return validateCNPJ(cnpj);
    }),
  riskClassification: yup
    .object()
    .nullable()
    .required('Selecione uma classificação de risco')
    .shape({
      key: yup.string().required('Selecione uma classificação de risco'),
      value: yup.string().required('Selecione uma classificação de risco')
    }),
  annualBilling: yup
    .number()
    .typeError('O campo Faturamento Mínimo deve ser um número')
    .nullable()
    .required('Digite um valor de faturamento anual'),
  creditLimit: yup
    .number()
    .typeError('O campo Límite de Crédito deve ser um número')
    .nullable()
    .required('Digite um valor de limite de crédito.'),
  socialCapital: yup
    .number()
    .typeError('O campo Capital Social deve ser um número')
    .nullable()
    .required('Digite um valor de capital social'),
  minApprovalSignatures: yup
    .number()
    .typeError('O campo Número Mínimo deve ser um número')
    .nullable()
    .required('Digite um número mínimo de assinaturas para aprovação'),
  constitutionDate: yup.string().nullable().required('Digite a data de constituição'),
  companyType: yup
    .object()
    .nullable()
    .required('Selecione tipo de sociedade')
    .shape({
      key: yup.string().required('Selecione o tipo de sociedade'),
      value: yup.string().required('Selecione o tipo de sociedade')
    }),
  companySize: yup
    .object()
    .nullable()
    .required('Selecione o porte')
    .shape({
      key: yup.string().required('Selecione o porte'),
      value: yup.string().required('Selecione o porte')
    }),
  receitaRegistrationStatus: yup
    .object()
    .nullable()
    .required('Selecione a situação cadastral na Receita')
    .shape({
      key: yup.string().required('Selecione a situação cadastral na Receita'),
      value: yup.string().required('Selecione a situação cadastral na Receita')
    })
});

export const assignorFormSchema = yup.object().shape({
  cnpj: yup
    .string()
    .nullable()
    .test('isValidCNPJ', 'Digite um CNPJ válido', function () {
      const { cpf, cnpj } = this.parent;
      if ((cpf && cnpj) || (!cpf && !cnpj)) {
        return this.createError({ message: 'Digite um CNPJ ou CPF' });
      }
      if (cpf) {
        return true;
      }

      return validateCNPJ(cnpj);
    }),
  cpf: yup
    .string()
    .nullable()
    .test('isValidCPF', 'Digite um CPF válido', function () {
      const { cpf, cnpj } = this.parent;
      if ((cpf && cnpj) || (!cpf && !cnpj)) {
        return this.createError({ message: 'Digite um CNPJ ou CPF' });
      }
      if (cnpj) {
        return true;
      }

      return validateCPF(cpf);
    }),
  fullName: yup.string().required('O campo é obrigatório'),
  personalEmail: yup.string().email('Digite um e-mail válido').required('O e-mail é obrigatório'),
  areaCode: yup
    .string()
    .required('O código de área é obrigatório')
    .matches(/^\d{2}$/, 'Código de área inválido'),
  phone: yup
    .string()
    .test('is-phone', 'O número de telefone deve conter 8 ou 9 dígitos', (value) => {
      if (!value) return false;
      const digitsOnly = value.replace(/\D/g, '');
      return digitsOnly.length === 8 || digitsOnly.length === 9;
    })
    .required('O número de telefone é obrigatório')
});

export const bankDetailsFormSchema = yup.object().shape({
  agency: yup
    .string()
    .matches(/^[0-9]+$/, 'Deve conter apenas números')
    .max(4, 'Deve ter no máximo 4 dígitos')
    .required('O campo é obrigatório'),
  bank: yup
    .object()
    .nullable()
    .required('Selecione o banco')
    .shape({
      key: yup.string().required('Selecione o banco'),
      value: yup.string().required('Selecione o banco')
    }),
  checkingAccount: yup
    .string()
    .matches(/^[0-9Xx]+$/, 'Deve conter apenas números ou o caractere X')
    .max(14, 'Deve ter no máximo 14 dígitos')
    .required('O campo é obrigatório'),
  bankDataNotes: yup.string().max(200, 'Deve ter no máximo 200 dígitos').required('O campo é obrigatório')
});
